import { NavGraph, NavGraphItem, Document } from 'src/types/navGraph';
import {
    NAV_GRAPH_ROOT_NODE_ID,
    NAV_GRAPH_ROOT_NODE_ID_V1,
    NAV_GRAPH_ROOT_NODE_ID_V2,
    USE_NAV_GRAPH_V2,
} from 'src/components/providers/NavGraphProvider';

const searchByDocumentId = (
    documentId: number,
    node: any
): Document | undefined => {
    if (node.documents && node.documents[documentId]) {
        return node.documents[documentId];
    }
    if (node.children) {
        for (const child of Object.values(node.children)) {
            const result = searchByDocumentId(documentId, child);
            if (result) return result;
        }
    }
    return undefined;
};

export const findInNavGraphV2 = (
    documentId: number,
    navGraph: NavGraph
): Document | undefined => {
    if (!navGraph) return undefined;

    for (const rootNode of Object.values(navGraph)) {
        const result = searchByDocumentId(documentId, rootNode);
        if (result) return result;
    }
    return undefined;
};

const findInPath = (
    paths: number[],
    node: NavGraph,
    accessor: keyof NavGraphItem
): NavGraphItem | undefined => {
    const path = paths.shift();
    const nextNavGraphItemKey = Object.keys(node).find((key) => {
        const nextNode = node[key];
        return nextNode[accessor] === path;
    });

    if (nextNavGraphItemKey === undefined) {
        return undefined;
    }

    const nextNode = node[nextNavGraphItemKey];
    if (!paths.length) {
        return nextNode;
    } else if (nextNode.children) {
        return findInPath(paths, nextNode.children, accessor);
    }
    return undefined;
};

export const findInNavGraph = (
    artifactId: number,
    path: string,
    node: NavGraph,
    accessor: keyof NavGraphItem
): Document | undefined => {
    if (!node) {
        return undefined;
    }
    // If a string needs to be selected, such as name, the path will need to be sent in as a param so that it can be mapped
    // Otherwise the findInPath === will throw an error on '123' === 123
    const paths = path
        .split('/')
        .filter(Boolean)
        .map((path) => parseInt(path))
        .filter((path) =>
            USE_NAV_GRAPH_V2
                ? path !== NAV_GRAPH_ROOT_NODE_ID_V2
                : path !== NAV_GRAPH_ROOT_NODE_ID_V1
        );

    const lastNodeInPath = findInPath(paths, node, accessor);
    if (lastNodeInPath && lastNodeInPath.documents) {
        return lastNodeInPath.documents[artifactId];
    }
    return undefined;
};
